import { LocalizedEnumApiModel } from '../../../api/journodex/model/localized-enum-api.model';
import { CirculationApiModel } from '../../../api/targeting/model/targeting-search-result.api.model';
import { LocalizedEnum } from '../../../api/journodex/model/localized-enum';
import { SortFieldEnum } from '../../../Common/TargetingShared/enum/SortField.enum';

export enum CirculationType {
    circulation = 'CIRCULATION', // print
    manualValue = 'UNIQUE_VISITORS', // online
    similarWebValue = 'SIMILARWEB_UNIQUE_VISITORS',
    partnerValue = 'UNIQUE_VISITORS_PARTNERS', // online
    viewers = 'VIEWERS',
    followers = 'FOLLOWERS',
    listeners = 'LISTENERS'
}

export const circulationTypeToSortType = new Map<CirculationType, SortFieldEnum>([
    [CirculationType.manualValue, SortFieldEnum.CIRCULATION_UNIQUE_VISITORS],
    [CirculationType.circulation, SortFieldEnum.CIRCULATION_CIRCULATION],
    [CirculationType.viewers, SortFieldEnum.CIRCULATION_VIEWERS],
    [CirculationType.followers, SortFieldEnum.CIRCULATION_FOLLOWERS],
    [CirculationType.listeners, SortFieldEnum.CIRCULATION_LISTENERS]
]);

export const circulationTypeToIconMap = new Map<CirculationType, string>([
    [CirculationType.circulation, 'fa-solid fa-arrows-spin'],
    [CirculationType.manualValue, 'fa-solid fa-id-badge'],
    [CirculationType.similarWebValue, 'fa-solid fa-id-badge'],
    [CirculationType.partnerValue, 'fa-solid fa-id-badge'],
    [CirculationType.viewers, 'fa-solid fa-eye'],
    [CirculationType.followers, 'fa-solid fa-user-group'],
    [CirculationType.listeners, 'fa-solid fa-head-side-headphones']
]);

export class CirculationModel {
    circulationType: LocalizedEnum;
    value: number;
    isSimilarWeb: boolean;

    constructor(apiModel?: CirculationApiModel) {
        if (apiModel) {
            this.circulationType = new LocalizedEnum(apiModel.circulationType);
            this.circulationType.displayString = this.circulationType.displayString.replace(/\s\(.*\)/g, '');
            this.value = apiModel.value;
            this.isSimilarWeb = this.circulationType.enumValue === CirculationType.similarWebValue;
        }
    }

    clone(): CirculationModel {
        const clone = new CirculationModel();
        clone.circulationType = new LocalizedEnum(<LocalizedEnumApiModel>this.circulationType);
        clone.value = this.value;
        clone.isSimilarWeb = this.isSimilarWeb;
        return clone;
    }
}

